import { fromJS } from 'immutable'
import * as actionTypes from './constants'
import { LOGOUT } from '../authentication/constants'

const initialState = fromJS({})

function projectSettingsReducer (state = initialState, action) {
  const pinCategories = state.get('pinCategories')
  const pictureType =
    action.logoType === actionTypes.REPORT_LOGO
      ? 'projectReportPicture'
      : 'projectPicture'
  switch (action.type) {
    case actionTypes.DELETE_PROJECT_PICTURE:
    case actionTypes.UPLOAD_PROJECT_PICTURE:
      return state.set(`${pictureType}Uploading`, true)
    case actionTypes.PROJECT_PICTURE_UPLOADED:
      return state
        .set(`${pictureType}Uploaded`, true)
        .set(`${pictureType}Uploading`, false)
    case actionTypes.PROJECT_PICTURE_UPLOAD_ERROR:
      return state
        .set(`${pictureType}Uploaded`, false)
        .set(`${pictureType}Uploading`, false)
        .set(`${pictureType}UploadError`, action.error)
    case actionTypes.SET_PROJECT_PICTURE:
      return state.set('projectPicture', action.projectPicture)
    case actionTypes.GET_PROJECT_PICTURE_ERROR:
      return state.set('setProjectPictureError', action.error)

    case actionTypes.CLEAR_PROJECT_DETAILS:
      return state
        .delete('gettingProjectDetails')
        .delete('projectDetails')
        .delete('getProjectDetailsError')
    case actionTypes.GET_PROJECT_DETAILS:
      return state
        .set('gettingProjectDetails', true)
        .delete('getProjectDetailsError')
    case actionTypes.SET_PROJECT_DETAILS:
      return state
        .set('projectDetails', action.project)
        .set('gettingProjectDetails', false)
    case actionTypes.GET_PROJECT_DETAILS_ERROR:
      return state
        .set('getProjectDetailsError', action.error)
        .set('gettingProjectDetails', false)
    case actionTypes.SAVE_PROJECT_DETAILS:
      return state.set('savingProjectDetails', true)
    case actionTypes.PROJECT_DETAILS_SAVED:
      return state.set('savingProjectDetails', false)
    case actionTypes.SAVE_PROJECT_DETAILS_ERROR:
      return state
        .set('savingProjectDetailsError', action.error)
        .set('savingProjectDetails', false)
    case actionTypes.CLEAR_PIN_CATEGORIES:
      return state.set('pinCategories', null)
    case actionTypes.SET_PIN_CATEGORIES:
      return state
        .set('pinCategories', action.pinCategories)
        .set('gettingPinCategories', false)
    case actionTypes.CREATE_AND_UPDATE_PIN_CATEGORIES:
      return state.set('savingPinCategory', true)
    case actionTypes.PIN_CATEGORIES_CREATED_AND_UPDATED:
      return state.set('savingPinCategory', false)
    case actionTypes.PIN_CATEGORY_CREATED:
      pinCategories.push(action.pinCategory)
      return state.set('pinCategories', pinCategories)
    case actionTypes.PIN_CATEGORY_UPDATED:
      pinCategories[action.index] = action.pinCategory
      return state.set('pinCategories', pinCategories)
    case actionTypes.GET_PIN_CATEGORIES:
      return state.set('gettingPinCategories', true)
    case actionTypes.GET_PIN_CATEGORIES_ERROR:
    case actionTypes.CREATE_AND_UPDATE_PIN_CATEGORIES_ERROR:
      return state
        .set('savingPinCategory', false)
        .set('pinCategoryError', action.error)

    case actionTypes.GET_TEMPLATES_OF_PROJECT:
      return state
        .set('gettingTemplatesOfProject', true)
        .delete('getTemplatesOfProjectError')
        .delete('templatesOfProject')
    case actionTypes.GET_TEMPLATES_OF_PROJECT_DONE:
      return state
        .set('gettingTemplatesOfProject', false)
        .set('templatesOfProjectTotalPages', action.totalPages)
        .set(
          'templatesOfProject',
          fromJS(action.templates).sortBy((t) => t.get('name').toLowerCase())
        )
    case actionTypes.GET_TEMPLATES_OF_PROJECT_ERROR:
      return state
        .set('gettingTemplatesOfProject', false)
        .set('getTemplatesOfProjectError', action.error)

    case actionTypes.GET_FIELDS:
      return state.set('gettingFields', true).delete('FieldsInProject')
    case actionTypes.GET_FIELDS_DONE:
      return state
        .set('gettingFields', false)
        .set('FieldsInProject', action.pinFields)
    case actionTypes.GET_FIELDS_ERROR:
      return state.set('gettingFields', false)

    case actionTypes.UPDATE_PIN_FIELD:
      return state.set('updatingPinField', true).delete('updatingPinFieldError')
    case actionTypes.UPDATE_PIN_FIELD_DONE:
      return state.set('updatingPinField', false)
    case actionTypes.UPDATE_PIN_FIELD_ERROR:
      return state
        .set('updatingPinField', false)
        .set('updatingPinFieldError', action.error)

    case actionTypes.CREATE_PIN_FIELD:
      return state.set('creatingPinField', true).delete('creatingPinFieldError')
    case actionTypes.CREATE_PIN_FIELD_DONE:
      return state
        .set('creatingPinField', false)
        .set('createdField', action.newFieldDetails)
    case actionTypes.CLEAR_CREATED_FIELD:
      return state.set('createdField', undefined)
    case actionTypes.CREATE_PIN_FIELD_ERROR:
      return state
        .set('creatingPinField', false)
        .set('creatingPinFieldError', action.error)
    case actionTypes.GET_ASSIGNABLE_TEMPLATES:
      return state.set('gettingAssignableTemplates', true)
    case actionTypes.GET_ASSIGNABLE_TEMPLATES_DONE:
      return state
        .set('gettingAssignableTemplates', false)
        .set('assignableTemplates', action.data.content)
        .set('assignableTotalPages', action.data.totalPages)
    case actionTypes.GET_ASSIGNABLE_TEMPLATES_ERROR:
      return state
        .set('gettingAssignableTemplates', false)
        .set('assignableTemplatesError', true)
    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default projectSettingsReducer
